export const iconFontAwesomeShoppingCcDiscover = (
	<i className="fa-solid fa-cc-discover"></i>
);
